import './scss/index.scss';

/**
 *  Calculator
 */

// Calculator Observer
if (document.querySelector('[data-calc-mini]')) {
  __WMS__.utils.observeElement({
    element: '[data-calc-mini]',
    marginValue: 300,
    callback: () => {
      __WMS__.utils.getWidget({
        widgetLink: '/assets/js/calc.js',
        loader: false,
        insertLoaderTo: '[data-calc-mini]',
        loaderPosition: 'center',
        fn: () => {
          const calcOptions = {
            ID: '197',
            calculatorType: 'DefaultCalculator',
            format: 'json',
            parent: '[data-calc-mini]',
          };

          if (window.Calc) {
            const calc = new Calc(calcOptions);/* eslint-disable-line */
          }
        },
      });
    },
  });
}

if (document.querySelector('[data-calc-short]')) {
  __WMS__.utils.observeElement({
    element: '[data-calc-short]',
    marginValue: 300,
    callback: () => {
      __WMS__.utils.getWidget({
        widgetLink: '/assets/js/calc.js',
        loader: true,
        fn: () => {
          const calcOptions = {
            ID: '197',
            calculatorType: 'DefaultCalculator',
            format: 'json',
            parent: '[data-calc-short]',
          };

          if (window.Calc) {
            const calc = new Calc(calcOptions);/* eslint-disable-line */
          }
        },
      });
    },
  });
}
